import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Mission() {
  return <section id="mission" className="py-24 bg-pac-sand relative overflow-hidden" data-id="element-133" data-mp="4soj7vv51rcu">
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 rounded-full bg-pac-gold/10 blur-3xl" data-id="element-134" data-mp="jh2ki2cwp7ra" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-135" data-mp="ejszcywjvi99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-136" data-mp="3n05mhyb2zvp1">
          <div className="inline-flex items-center justify-center p-3 bg-pac-navy text-pac-gold rounded-full mb-6 shadow-lg" data-id="element-137" data-mp="3s0a11isfigcm">
            <ShieldCheck className="h-8 w-8" data-id="element-138" data-mp="17888x5wwx8d7" />
          </div>
          <p className="text-pac-red font-bold uppercase tracking-[0.2em] text-sm mb-3" data-id="element-139" data-mp="177oonijsi7w0">
            Arizona City Political Action Committee
          </p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-pac-navy mb-8" data-id="element-140" data-mp="1n8j7x6gh6krv">
            Our Mission
          </h2>

          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl border border-slate-100 text-left" data-id="element-141" data-mp="1rbfj4c3orels">
            <div className="space-y-6 text-lg md:text-xl text-slate-700 leading-relaxed font-medium" data-id="element-142" data-mp="1w97oa7tccx7x">
              <p data-id="element-143" data-mp="zlktsfftvox4">
                AZ City PAC is a statewide coalition of mayors, councilmembers,
                business leaders, and community advocates committed to
                protecting local control and advancing policies that strengthen
                Arizona&apos;s cities and towns.
              </p>
              <p data-id="element-144" data-mp="1dczfwv51868e">
                We advocate for legislation that preserves local authority over
                zoning, land use, infrastructure, and community planning while
                fostering responsible economic development, enhancing public
                safety, and protecting the quality of life of the residents we
                serve.
              </p>
              <p data-id="element-145" data-mp="1j65170fyjhij">
                By building bipartisan partnerships and promoting collaboration
                between the public and private sectors, Arizona City PAC works
                to ensure local leaders retain the ability to make decisions
                that reflect the unique needs, values, and priorities of their
                communities.
              </p>
              <p className="text-pac-navy" data-id="element-146" data-mp="108u1jeqeym2k">
                Our mission is to unite Arizona&apos;s municipal leaders and
                stakeholders to champion policies that create strong local
                economies, resilient infrastructure, safe neighborhoods, and
                thriving communities for generations to come.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}